
import { Options, Prop, Vue } from 'vue-property-decorator'

import RtlPlus from '../icons/RtlPlus.vue'

@Options({
  name: 'UefaTeamTable'
})
export default class UefaTeamTable extends Vue {
  @Prop({
    type: Array,
    default: () => []
  })
  readonly contents!: Array<{
    name: string
    logo: string
    country?: string
    matchesPlayed: number
    matchesWon: number
    matchesLost: number
    matchesDrawn: number
    goalsFor: number
    goalsAgainst: number
    goalDifference: string
    points: number
    results: Array<'won' | 'lost' | 'drawn'>
  }>
}
